/**
 * Planhat is a tool used by CS. It has an integration with the data warehouse (DW)
 * and gets its data from there. We also connect it to Mixpanel, but for that we need
 * to send ID's (login Id's, site Id's, org Id's) in the same format as they
 * appear in the data warehouse.
 *
 * They look like this: `aws|<ID>` (.co) OR `bh|<ID>` (bright horizon) OR `azure|<ID>` (famly.de).
 *
 * Currently we only have Mixpanel enabled in the "aws environment" (famly.co)
 * so we use that as a justification to hardcode things here.
 */

export const getPlanhatProperties = (loginId: string, siteId?: string, orgId?: string) => {
    const dwSiteIdConfig = siteId ? {['dw_siteId']: `aws|${siteId}`} : {};
    const dwOrgIdConfig = orgId ? {['dw_orgId']: `aws|${orgId}`} : {};

    return {
        ['dw_loginId']: `aws|${loginId}`,
        ...dwSiteIdConfig,
        ...dwOrgIdConfig,
    };
};
